import styled, {css} from 'styled-components';

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    ${props => props.white
        ? `border: solid 0.5px #ffffff;`
        : `border: solid 0.5px #979797;`
    }
`;

const text = css`
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
`;

export const Footnote = styled.div`
    ${text}
    ${props => props.useChinese
        ? `font-family: 'Microsoft JhengHei', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    font-size: 90%;
`;

export const Warning = styled.div`
    font-family: Arial;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ff0000;
`;

// export const FormTitle = styled.div`
//     font-family: Arial;
//     font-size: 30px;
//     font-weight: normal;
//     font-style: normal;
//     font-stretch: normal;
//     line-height: normal;
//     letter-spacing: normal;
//     color: #000000;
//     margin-top: 23px;
//     margin-bottom: 28px;
// `;

// export const GreenTitle = styled.span`
//     color: #0c9600;
// `;

// export const AltGreenTitle = styled.span`
//     color: #08a000;
// `;

export const FormHeading = styled.div`
    ${props => props.useChinese
        ? `font-family: 'Microsoft JhengHei', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    font-size: 20px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
`;

export const Title = styled.div`
    ${props => props.useChinese
        ? `font-family: 'Microsoft JhengHei', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    font-size: 1.4rem;
    display: flex;
    border-style: solid;
    border-width: 0px 0px 1px 0px;
    border-color: black;
    padding-top: 10px;
`;



export const OptionText = styled.div`
    ${text}
    ${props => props.useChinese
        ? `font-family: 'Microsoft JhengHei', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    font-size: 16px;
    color: #000000;
`;

export const PolicyHeader = styled.div`
    font-family: Arial;
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
    margin-top: 14px;
    margin-left: 12px;
    margin-bottom: 9px;
`;

export const PolicyText = styled.div`
    ${text}
    ${props => props.useChinese
        ? `font-family: 'Microsoft JhengHei', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    color: #ffffff;
    font-size: 16px;
`;

export const PolicyTextSmall = styled.div`
    ${text}
    ${props => props.useChinese
        ? `font-family: 'Microsoft JhengHei', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    color: #ffffff;
    font-size: 12px;
`;

export const MobileContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 12px;
    margin-bottom: 12px;
`;
